import { HeaderContext, useHeaderContextValue } from './HeaderContext';
import type { PropsWithChildren } from 'react';

export const HeaderContextProvider = ({ children }: PropsWithChildren<unknown>) => {
    const headerContextValue = useHeaderContextValue();

    return <HeaderContext.Provider value={headerContextValue}>{children}</HeaderContext.Provider>;
};
